module.exports = require('./MessageModal.action')



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Modal/MessageModal/index.js